// Geometry helpers: world-UV boxes, octagons, rounded rectangles, prisms, arches, spires.
import * as THREE from 'three';
import { PI } from './math.js';

// box whose UVs are in world units, so tiled textures keep their scale
export function boxW(w, h, d) {
  const g = new THREE.BoxGeometry(w, h, d),
    uv = g.attributes.uv,
    dims = [
      [d, h],
      [d, h],
      [w, d],
      [w, d],
      [w, h],
      [w, h],
    ];
  for (let f = 0; f < 6; f++)
    for (let k = 0; k < 4; k++) {
      const i = f * 4 + k;
      uv.setXY(i, uv.getX(i) * dims[f][0], uv.getY(i) * dims[f][1]);
    }
  return g;
}
export function octPts(s, ch) {
  const h = s / 2;
  return [
    [-h + ch, -h],
    [h - ch, -h],
    [h, -h + ch],
    [h, h - ch],
    [h - ch, h],
    [-h + ch, h],
    [-h, h - ch],
    [-h, -h + ch],
  ];
}
export function octShape(s, ch, holeS, holeCh) {
  const sh = new THREE.Shape();
  const p = octPts(s, ch);
  sh.moveTo(...p[0]);
  for (let i = 1; i < 8; i++) sh.lineTo(...p[i]);
  sh.closePath();
  if (holeS) {
    const hp = octPts(holeS, holeCh),
      h = new THREE.Path();
    h.moveTo(...hp[0]);
    for (let i = 1; i < 8; i++) h.lineTo(...hp[i]);
    h.closePath();
    sh.holes.push(h);
  }
  return sh;
}

// extruded footprint standing on the ground (extrusion goes up)
export function slabGeo(shape, depth, bevel = 0) {
  const g = new THREE.ExtrudeGeometry(shape, {
    depth,
    curveSegments: 10,
    bevelEnabled: bevel > 0,
    bevelSize: bevel,
    bevelThickness: bevel,
    bevelSegments: 2,
  });
  g.rotateX(-PI / 2);
  return g;
}
export function prism(w, h, len) {
  const s = new THREE.Shape();
  s.moveTo(-w / 2, 0);
  s.lineTo(w / 2, 0);
  s.lineTo(0, h);
  s.closePath();
  const g = new THREE.ExtrudeGeometry(s, { depth: len, bevelEnabled: false });
  g.translate(0, 0, -len / 2);
  return g;
}
export function archGeo(w, h) {
  const s = new THREE.Shape();
  s.moveTo(-w / 2, 0);
  s.lineTo(w / 2, 0);
  s.lineTo(w / 2, h * 0.68);
  s.quadraticCurveTo(w / 2, h * 0.92, 0, h);
  s.quadraticCurveTo(-w / 2, h * 0.92, -w / 2, h * 0.68);
  s.closePath();
  return new THREE.ShapeGeometry(s);
}
// Gaudí bell tower body: near-cylinder that tapers parabolically
export function spire(R0, Hs, taper = 0.78, seg = 12) {
  const pts = [];
  for (let i = 0; i <= 20; i++) {
    const t = i / 20;
    pts.push(new THREE.Vector2(Math.max(0.05, R0 * (1 - taper * Math.pow(t, 2.4))), t * Hs));
  }
  return new THREE.LatheGeometry(pts, seg);
}
